/* eslint-disable indent */
import { useTranslation } from 'react-i18next';
import { useUserRole } from '@/hooks/auth.hooks';
import MenuItem from './MenuItem';
import SubItem from './SubItem';
import { Link } from 'react-router-dom';
import { DashboardIcon } from '../SvgIcons/DashboardIcon';
import { StructureIcon } from '../SvgIcons/StructureIcon';
import { BorderedEqualizerIcon } from '../SvgIcons/BorderedEqualizerIcon';
import { SettingsIcon } from '../SvgIcons/SettingsIcon';
import { SecurityIcon } from '../SvgIcons/SecurityIcon';
import { EuroIcon } from '../SvgIcons/EuroIcon';
import { API_BASE_URL, isProd } from '@/utils/constant.utils';
import { clearLocalStorageFilters } from '@/utils/clear-local-storage-filters.utils';

const SideBarMenu = () => {
  const { t } = useTranslation('sidebar');
  const {
    hasNoRole,
    isAdmin,
    isModerator,
    isCompanyManager,
    // isGroupManager,
    isBranchManager,
    isBranchAgent,
  } = useUserRole();

  const dashboardMenuActive = location.pathname.startsWith('/dashboard');

  const structureMenuActive =
    location.pathname.startsWith('/group') ||
    location.pathname.startsWith('/compan') ||
    location.pathname.startsWith('/branch');

  const operationsMenuActive =
    location.pathname.startsWith('/user') ||
    location.pathname === '/vehicules' ||
    location.pathname.startsWith('/vehicule/') ||
    location.pathname.startsWith('/vehicule-checks') ||
    location.pathname.startsWith('/vehicule-check/') ||
    location.pathname.startsWith('/vehicule-check-request') ||
    location.pathname.startsWith('/endpoints');

  const settingsMenuActive =
    location.pathname.startsWith('/check-point') ||
    location.pathname.startsWith('/equipment') ||
    location.pathname.startsWith('/damage') ||
    location.pathname.startsWith('/vehicule-check-type') ||
    location.pathname.startsWith('/email-template') ||
    location.pathname.startsWith('/email-settings') ||
    location.pathname.startsWith('/requested-app-update');

  const costingMenuActive =
    location.pathname.startsWith('/repair-service') ||
    location.pathname.startsWith('/repair-costing');

  const administrationMenuActive =
    location.pathname.startsWith('/kpi-moteur') ||
    location.pathname.startsWith('/evolution-kpi-moteur') ||
    location.pathname.startsWith('/moteur-de-correction-liste') ||
    location.pathname.startsWith('/engine-correction');

  return (
    <div
      className="sidebar-content flex grow shrink-0 py-5 pr-2"
      id="sidebar_content"
    >
      <div
        className="scrollable-y-hover grow shrink-0 flex pl-2 lg:pl-5 pr-1 lg:pr-3"
        data-scrollable="true"
        data-scrollable-dependencies="#sidebar_header"
        data-scrollable-height="auto"
        data-scrollable-offset="0px"
        data-scrollable-wrappers="#sidebar_content"
        id="sidebar_scrollable"
      >
        <div
          className="menu flex flex-col grow"
          data-menu="true"
          data-menu-accordion-expand-all="false"
          id="sidebar_menu"
        >
          {hasNoRole ? (
            <MenuItem
              title={t('operations')}
              icon={BorderedEqualizerIcon}
              iconClassName="w-[17px] h-[17px] ml-[1.25px] [&>path]:!fill-none [&>path]:stroke-gray-99A1B6 [&>path]:menu-item-active:stroke-black-252E49 [&>path]:dark-mode:menu-link-hover:stroke-gray-900 [&>path]:dark-mode:menu-item-active:stroke-gray-900"
              active={operationsMenuActive}
            >
              <SubItem
                title={t('common:users')}
                to="/users"
                active={location.pathname.startsWith('/user')}
              />
            </MenuItem>
          ) : (
            <>
              {!isModerator && (
                <Link
                  to="/dashboard"
                  onClick={() => clearLocalStorageFilters()}
                  className="sidebar-collapse-hide"
                >
                  <MenuItem
                    title={t('common:dashboard')}
                    icon={DashboardIcon}
                    active={dashboardMenuActive}
                  />
                </Link>
              )}
              <MenuItem
                title={t('structure')}
                icon={StructureIcon}
                iconClassName="w-[21px] h-[21px] [&>path]:!fill-none [&>path]:stroke-gray-99A1B6 [&>path]:menu-item-active:stroke-black-252E49 [&>path]:dark-mode:menu-link-hover:stroke-gray-900 [&>path]:dark-mode:menu-item-active:stroke-gray-900"
                active={structureMenuActive}
              >
                {!isCompanyManager && !isBranchManager && !isBranchAgent && (
                  <SubItem
                    title={t('common:groups')}
                    to="/groups"
                    active={location.pathname.startsWith('/group')}
                  />
                )}
                {!isModerator && (
                  <>
                    {!isBranchManager && !isBranchAgent && (
                      <SubItem
                        title={t('common:companies')}
                        to="/companies"
                        active={location.pathname.startsWith('/compan')}
                      />
                    )}
                    <SubItem
                      title={t('common:branches')}
                      to="/branches"
                      active={location.pathname.startsWith('/branch')}
                    />
                  </>
                )}
              </MenuItem>
              <MenuItem
                title={t('operations')}
                icon={BorderedEqualizerIcon}
                iconClassName="w-[17px] h-[17px] ml-[1.25px] [&>path]:!fill-none [&>path]:stroke-gray-99A1B6 [&>path]:menu-item-active:stroke-black-252E49 [&>path]:dark-mode:menu-link-hover:stroke-gray-900 [&>path]:dark-mode:menu-item-active:stroke-gray-900"
                active={operationsMenuActive}
              >
                <SubItem
                  title={t('common:users')}
                  to="/users"
                  active={location.pathname.startsWith('/user')}
                />
                {!isModerator && (
                  <SubItem
                    title={t('common:vehicules')}
                    to="/vehicules"
                    active={
                      location.pathname === '/vehicules' ||
                      location.pathname.startsWith('/vehicule/')
                    }
                  />
                )}
                <SubItem
                  title={t('common:inspections')}
                  to="/vehicule-checks"
                  active={
                    location.pathname !== '/vehicule-check/usage' &&
                    (location.pathname.startsWith('/vehicule-checks') ||
                      location.pathname.startsWith('/vehicule-check/'))
                  }
                />
                {!isModerator && (
                  <SubItem
                    title={t('common:doRequestAnInspection')}
                    to="/vehicule-check-request/create"
                    active={
                      location.pathname === '/vehicule-check-request/create'
                    }
                  />
                )}
                <SubItem
                  title={t('common:vehiculeCheckRequests')}
                  to="/vehicule-check-requests"
                  active={
                    location.pathname !== '/vehicule-check-request/create' &&
                    location.pathname.startsWith('/vehicule-check-request')
                  }
                />
                {isAdmin && (
                  <SubItem
                    title={t('common:inspectionUsage')}
                    to="/vehicule-check/usage"
                    active={location.pathname.startsWith(
                      '/vehicule-check/usage',
                    )}
                  />
                )}
                {isAdmin && (
                  <>
                    <SubItem
                      title={t('common:endpoints')}
                      to="/endpoints"
                      active={location.pathname === '/endpoints'}
                    />
                    <SubItem
                      title={t('common:api')}
                      to={`${API_BASE_URL}/api`}
                      openInNewTab
                    />
                  </>
                )}
              </MenuItem>
              {isAdmin && (
                <MenuItem
                  title={t('common:settings')}
                  icon={SettingsIcon}
                  iconClassName="w-[20px] h-[20px] [&>path]:!fill-none [&>path]:stroke-gray-99A1B6 [&>path]:menu-item-active:stroke-black-252E49 [&>path]:dark-mode:menu-link-hover:stroke-gray-900 [&>path]:dark-mode:menu-item-active:stroke-gray-900"
                  active={settingsMenuActive}
                >
                  {/* <SubItem title={t('myLucius')} to="#" /> */}
                  <SubItem
                    title={t('common:checkPoints')}
                    to="/check-points"
                    active={
                      location.pathname === '/check-points' ||
                      location.pathname.startsWith('/check-point/')
                    }
                  />
                  <SubItem
                    title={t('common:equipments')}
                    to="/equipments"
                    active={
                      location.pathname === '/equipments' ||
                      location.pathname.startsWith('/equipment/')
                    }
                  />
                  <SubItem
                    title={t('common:damages')}
                    to="/damages"
                    active={
                      location.pathname === '/damages' ||
                      location.pathname.startsWith('/damage/')
                    }
                  />
                  <SubItem
                    title={t('common:inspectionTypes')}
                    to="/vehicule-check-types"
                    active={
                      location.pathname === '/vehicule-check-types' ||
                      location.pathname.startsWith('/vehicule-check-type/')
                    }
                  />
                  <SubItem
                    title={
                      <>
                        <span>{t('common:email')}</span>
                        &nbsp;&#8212;&nbsp;
                        <span>{t('common:templates')}</span>
                      </>
                    }
                    to="/email-templates"
                    active={location.pathname.startsWith('/email-template')}
                  />
                  <SubItem
                    title={
                      <>
                        <span>{t('common:email')}</span>
                        &nbsp;&#8212;&nbsp;
                        <span>{t('common:automation')}</span>
                      </>
                    }
                    to="/email-settings"
                    active={location.pathname === '/email-settings'}
                  />
                  <SubItem
                    title={t('common:requestedAppUpdate')}
                    to="/requested-app-update"
                    active={
                      location.pathname === '/requested-app-update' ||
                      location.pathname.startsWith('/requested-app-update/')
                    }
                  />
                </MenuItem>
              )}
              {isModerator && (
                <MenuItem
                  title={t('common:settings')}
                  icon={SettingsIcon}
                  iconClassName="w-[20px] h-[20px] [&>path]:!fill-none [&>path]:stroke-gray-99A1B6 [&>path]:menu-item-active:stroke-black-252E49 [&>path]:dark-mode:menu-link-hover:stroke-gray-900 [&>path]:dark-mode:menu-item-active:stroke-gray-900"
                  active={settingsMenuActive}
                >
                  <SubItem
                    title={t('common:equipments')}
                    to="/equipments"
                    active={
                      location.pathname === '/equipments' ||
                      location.pathname.startsWith('/equipment/')
                    }
                  />
                </MenuItem>
              )}
              {isAdmin && (
                <MenuItem
                  title={t('common:costings')}
                  icon={EuroIcon}
                  iconClassName="w-[21.5px] h-[21.5px]"
                  active={costingMenuActive}
                >
                  <SubItem
                    title={t('common:repairServices')}
                    to="/repair-services"
                    active={location.pathname.startsWith('/repair-service')}
                  />
                  <SubItem
                    title={t('common:repairCostings')}
                    to="/repair-costings"
                    active={location.pathname.startsWith('/repair-costing')}
                  />
                </MenuItem>
              )}
              {(isAdmin || isModerator) &&
                (isProd || import.meta.env.MODE === 'development') && (
                  <MenuItem
                    title={t('administration')}
                    icon={SecurityIcon}
                    iconClassName="w-[21.5px] h-[21.5px]"
                    active={administrationMenuActive}
                  >
                    {isAdmin && (
                      <>
                        <SubItem
                          title={t('kpiMotor')}
                          to="/kpi-moteur"
                          active={location.pathname.startsWith('/kpi-moteur')}
                        />
                        <SubItem
                          title={t('kpiEvolution')}
                          to="/evolution-kpi-moteur"
                          active={location.pathname.startsWith(
                            '/evolution-kpi-moteur',
                          )}
                        />
                      </>
                    )}
                    {(isAdmin || isModerator) && (
                      <SubItem
                        title={t('common:engineCorrection')}
                        to="/moteur-de-correction-liste"
                        active={
                          location.pathname.startsWith(
                            '/moteur-de-correction-liste',
                          ) ||
                          location.pathname.startsWith('/engine-correction')
                        }
                      />
                    )}
                  </MenuItem>
                )}

              {/* <MenuItem title="IA" icon="ki-abstract-25">
            <SubItem title="Historique" to="/history" />
            <SubItem title="Détourage" to="/remove-car-background" />
            <SubItem title="Orientation" to="/detect-car-orientation" />
            <SubItem title="Eléments" to="/detect-car-element" />
            <SubItem title="Dommages" to="/detect-car-damage" />
            <SubItem
              title="Lecture d'immmatriculation"
              to="/reading-car-registration-id"
            />
            <SubItem
              title="Lecture de carte grise"
              to="/read-carte-grise"
            />
            <SubItem
              title="Moteur de correction"
              to="/moteur-de-correction-liste"
            />
          </MenuItem> */}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SideBarMenu;
